import { colorsByMedium } from 'modules/messagingInsights/constants';
import { Fragment } from 'react';
import styled from 'styled-components';
import { ScrollArea } from 'ui/scrollArea';
import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { Table } from './MetricsTable.styled';
import { TableData } from './MetricsTable.types';
import { getMetricValueText } from './MetricsTable.utils';
import { METRICS_TABLE_TEST_IDS } from './MetricsTable.constants';
import { CAMPAIGNS_TABLE_METRICS } from '../CampaignsHealthMetrics.constants';

const Cell = styled.div`
  color: ${colors.textSecondary};
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

const ValueCell = styled(Cell)`
  justify-content: flex-end;
  text-transform: lowercase;
`;

const LegendMarker = styled.div`
  min-width: ${pxToRem(11)};
  height: ${pxToRem(11)};
  border-radius: 50%;
`;

const Body = styled.div`
  margin: 0 -${spacing.plusHalf};
  overflow: hidden;
`;

const StyledTable = styled(Table)`
  padding: ${spacing.threeQuarter} ${spacing.plusHalf} ${spacing.plusHalf};

`;

export const MetricsTableBody = ({ allTableData = [] }: { allTableData: TableData }) => {
  return (
    <Body>
      <ScrollArea>
        <StyledTable>
          {allTableData.map(({ mediumName, metricsData }) => {
            const chartColor = colorsByMedium[mediumName] || colors.red50;

            return (
              <Fragment key={mediumName}>
                <Cell role="cell" data-test={METRICS_TABLE_TEST_IDS.MEDIUM_CELL}>
                  <LegendMarker style={{ backgroundColor: chartColor }} />
                  {mediumName}
                </Cell>
                {Object.entries(metricsData)
                  .sort((a, b) => {
                    const aIndex = CAMPAIGNS_TABLE_METRICS.indexOf(a[0]);
                    const bIndex = CAMPAIGNS_TABLE_METRICS.indexOf(b[0]);
                    return aIndex - bIndex;
                  })
                  .map(([metricName, metricValue]) => (
                    <ValueCell
                      key={metricName}
                      role="cell"
                      data-test={METRICS_TABLE_TEST_IDS.VALUE_CELL}
                    >
                      {getMetricValueText(metricName, metricValue)}
                    </ValueCell>
                  ))}
              </Fragment>
            );
          })}
        </StyledTable>
      </ScrollArea>
    </Body>
  );
};
